/*global TTApplicationEnum, TTPermissionEnum, _moovilaSecurity, TTImpersonationStatusEnum */
/*eslint no-undef: "error"*/

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import cx from 'classnames';

import { v2Api } from 'moovila-common';

import { CustomDialog, QuestionBox, Loading } from 'moovila-common';
import { redirectToApp } from '../../utilities/redirect';

const ecPermissions = [
  TTPermissionEnum.UP_USER_ADMIN,
  TTPermissionEnum.UP_ROLE_ADMIN,
  TTPermissionEnum.UP_ENTERPRISE_PROFILE,
  TTPermissionEnum.UP_CHANNEL_ADMIN,
  TTPermissionEnum.UP_SUBSCRIPTION_CHANNEL_SELECTION,
  TTPermissionEnum.UP_PUBLICATION_APPROVAL,
  TTPermissionEnum.UP_BROADCAST_ADMIN,
  TTPermissionEnum.UP_SUBSCRIPTION_APPROVAL,
  TTPermissionEnum.UP_REPORTS,
];

class ImpersonateUserModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: '',
      app: null,
      redirectToHome: false,
      userPermissionObject: null,
      stillActiveChecked: false,
      userIsStillActive: false,
      timeout: null,
      timerStarted: null,
      userName: '',
    }
    this.resetModal   = this.resetModal.bind(this);
    this.hasECAccess  = this.hasECAccess.bind(this);
    this.impersonate  = this.impersonate.bind(this);
    this.getStatus    = this.getStatus.bind(this);
  }

  componentWillMount() {
    v2Api
      .fetch('Security/GetUserPermissionsInfo', { userGUID: this.props.primaryGUID })
      .then(({data}) => this.setState({userPermissionObject: data}));
    v2Api
      .fetch('User/GetUserInfo', { userGUID: this.props.primaryGUID })
      .then(({data}) => this.setState({
        stillActiveChecked: true,
        userIsStillActive: data.userActive && data.userConfirmed
      }));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userInfo) {
      const {
        userDisplayName,
        userFirstName,
        userLastName,
      } = nextProps.userInfo;

      const userName = userFirstName && userLastName ? `${userFirstName} ${userLastName}` : userDisplayName;

      this.setState({userName});
    }
  }

  componentWillUnmount() {
    // if user chooses to leave modal, let's kill the local timeout
    // and setup a global one that's controlled at the top of the component tree
    if (this.state.timeout) {
      clearTimeout(this.state.timeout);
      this.setState({
        timeout: null,
      });
      // for now we are only allowing impersonations into Moovila
      // we'll need to move the app choice to state if we go back to EC and MOM
      this.props.setupGlobalImpersonation(TTApplicationEnum.MOOVILA, this.props.userInfo.userGUID, this.state.userName);
    }
  }

  resetModal() {
    this.setState({
      message: '',
      app: null,
    });
  }

  hasECAccess() {
    if (!this.state.userPermissionObject) {
      return false;
    }
    return ecPermissions.some((permission) => _moovilaSecurity.CheckPermission(permission, this.state.userPermissionObject));
  }

  getStatus() {
    if  (this.props.impersonatedUsers && this.props.impersonatedUsers.some(u => {
          return u.userGUID === this.props.userInfo.userGUID && u.impersonationStatusCode === TTImpersonationStatusEnum.IS_PENDING
    })) {
      return 'pending';
    }
    if  (this.props.impersonatedUsers && this.props.impersonatedUsers.some(u => {
          return u.userGUID === this.props.userInfo.userGUID && u.impersonationStatusCode === TTImpersonationStatusEnum.IS_ACTIVE
    })) {
      return 'active';
    }
    return null;
  }

  impersonate(APP, userName='', confirmed=false) {
    if (!this.state.timeout) {
      let appName = '';
      switch(APP) {
        case TTApplicationEnum.MOOVILA:
          appName = 'Moovila';
          break;
        case TTApplicationEnum.ENTERPRISE_CONSOLE:
          appName = 'Enterprise Console';
          break;
        case TTApplicationEnum.MOM:
          appName = 'MOM';
          break;
        default:
          return;
      }
      if (!confirmed) {
        this.setState({
          message: this.getStatus() === 'active' ?
              `You are about to connect to ${appName} as ${userName}. Are you sure?`
            :
              `You are about to request a RemoteAssist session into ${appName} as ${userName}. Are you sure?`
          ,
          app: APP,
        });
        return;
      }
      this.setState({
        message: '',
        app: null,
      });
    }

    v2Api
      .fetch('Security/ImpersonateUser', {userGUID: this.props.userInfo.userGUID})
      .then(({data}) => {
        if (data.hasActiveImpersonation) {
          if (APP !== TTApplicationEnum.MOM) {
            redirectToApp(APP, data.impersonationSessionGUID, true);
          } else {
            redirectToApp(APP, data.impersonationSessionGUID, false);
          }
          this.setState({
            timeout: null,
            timerStarted: null,
          });
        } else {
          if (moment(this.state.timerStarted).add(5, 'm').isBefore(moment())) {
            // kill it and notify it was never approved
            this.props.showMessageBox({
              title: 'Request Expired',
              message: `Your RemoteAssist request to ${this.state.userName} has expired`
            })
            this.setState({
              timeout: null,
              timerStarted: null,
            });
            return;
          }
          // setup dat timeout!
          this.setState({
            timeout: setTimeout(() => this.impersonate(APP, userName, confirmed), 5000),
          });
        }
      })
      .catch(({errCode, errMessage}) => {
        this.props.showMessageBox({
          title: 'Houston, there was a problem',
          message: errMessage,
        });
        this.setState({
          timeout: null,
          timerStarted: null,
        });
        return;
      });
  }

  render() {
    if (this.state.redirectToHome) {
      return <Redirect to='/home' />
    }

    if (!this.state.stillActiveChecked) {
      return <Loading />
    }

    if (!this.state.userIsStillActive) {
      this.props.showMessageBox({
        title: 'User Not Active',
        message: 'The user selected is no longer active',
      });
      this.props.getEnterpriseUsers(this.props.enterpriseGUID);
      return <Redirect to={`/admin/enterprise-maintenance/users/${this.props.enterpriseGUID}`} />
    }

    if (this.state.message) {
      return (
        <QuestionBox
          title='RemoteAssist'
          yesCallback={() => {
            this.setState({
              timerStarted: moment(),
            });
            this.impersonate(this.state.app, null, true);
          }}
          noCallback={this.resetModal}
        >
          {this.state.message}
        </QuestionBox>
      );
    }

    const {
      enterpriseGUID,
      userEmailAddress,
    } = this.props.userInfo;

    const enterprise = this.props.enterprises.filter(enterprise => enterprise.enterpriseGUID === enterpriseGUID)[0];
    const enterpriseName = enterprise && enterprise.enterpriseName ? enterprise.enterpriseName : '';
    const status = this.getStatus();
    const btnClass = cx({
      'btn btn-default btn-block btn-md': true,
      'disabled': status === 'pending' || this.state.timerStarted, 
    })

    const buttons = (
      <div className='impersonate__buttons'>
        <p>
          <button className={btnClass} onClick={() => {
            if (status === 'pending' || this.state.timerStarted) {
              return;
            }
            this.impersonate(TTApplicationEnum.MOOVILA, this.state.userName)
          }}>
            {
              status || this.state.timerStarted ?
                status === 'active' ?
                  <span>Open Moovila as this user</span>
                :
                  <span>Pending</span>
              :
                <span>Request RemoteAssist for this user</span>
            }
          </button>
        </p>
        {/* this.hasECAccess() ? (
          <p>
            <button className='btn btn-default btn-block btn-md' onClick={() => this.impersonate(TTApplicationEnum.ENTERPRISE_CONSOLE, name)}>
              Open Enterprise Console as this user
            </button>
          </p>
        ) : null }
        <p>
          <button className='btn btn-default btn-block btn-md' onClick={() => this.impersonate(TTApplicationEnum.MOM, name)}>
            Open MOM as this user
          </button>
        </p> */}
      </div>
    );
    return (
      <CustomDialog
        size='md'
        title={<span><i className='fa fa-user-secret'></i> RemoteAssist</span>}
        backTo={`/admin/enterprise-maintenance/users/${this.props.enterpriseGUID}`}
        buttons={buttons}
      >
        <section className='section'>
          <div className='row'>
            <div className='col-xs-12 form-group'>
                <h3 className='text-primary'>Enterprise: <span className='plain-labels'>{enterpriseName}</span></h3>
            </div>
            <div className='col-xs-12 form-group'>
                <h3 className='text-primary'>User Name: <span className='plain-labels'>{this.state.userName}</span></h3>
                <h3 className='text-primary'>User Email: <span className='plain-labels'>{userEmailAddress}</span></h3>
            </div>
          </div>
        </section>
      </CustomDialog>
    );
  }

}

export default ImpersonateUserModal;



// WEBPACK FOOTER //
// ./src/components/Admin/ImpersonateUserModal.js